import { Controller } from "@hotwired/stimulus";
import { seemsOffline, visit } from "../utils/connectivity";
import { isPwaEnabled } from "../utils/offline_gating";
import { quizQuestionUrl, cacheQuizUrl, isQuizUrlCached } from "../utils/quiz_offline_cache";

export default class extends Controller {
  static values = { quizId: Number, totalQuestions: Number };
  static outlets = ["offline-navigation"];

  connect() {
    if (!isPwaEnabled()) return;
    if (seemsOffline()) return;
    this.seedCache();
  }

  async seedCache() {
    if (!this.quizIdValue || !this.totalQuestionsValue) return;

    const urls = [];
    for (let i = 1; i <= this.totalQuestionsValue; i++) {
      urls.push(quizQuestionUrl(this.quizIdValue, i));
    }

    await Promise.all(
      urls.map(async (url) => {
        if (await isQuizUrlCached(url)) return;
        await cacheQuizUrl(url);
      })
    );
  }

  async guard(event) {
    if (!seemsOffline()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const trigger = event.currentTarget;

    const firstUrl = quizQuestionUrl(this.quizIdValue, 1);
    if (firstUrl && (await isQuizUrlCached(firstUrl))) {
      if (this.hasOfflineNavigationOutlet) {
        this.offlineNavigationOutlet.showStudyModeNotice(firstUrl, trigger);
      } else {
        visit(firstUrl);
      }
      return;
    }
    if (this.hasOfflineNavigationOutlet) {
      this.offlineNavigationOutlet.showFeatureUnavailable(trigger);
    }
  }
}
